







import { defineComponent, PropType, computed } from '@vue/composition-api';
import useCss from '@berlin-front/common/composables/useCss';
import { useContext } from '@berlin-front/common/composables/context';
import { ThemeContext } from '@berlin-front/common/services/ThemeContext';
import { bemx } from '@berlin-front/common/utils';
import {
  LETTER_SPACING_MAP,
  LetterSpacing,
  LINE_HEIGHT_MAP,
  LineHeight,
  TEXT_SIZE,
  TextSize,
  TEXT_SIZE_MAP,
  TEXT_WEIGHT,
  TEXT_WEIGHT_MAP,
  TextWeight,
  TextColor,
  TEXT_COLOR,
  TEXT_COLOR_MAP,
  SIZE_HEIGHT_MAP,
} from './composable';

/**
 * ## テキスト表示コンポーネント。
 *
 * 雛形のみ未実装。
 */
export default defineComponent({
  name: 'AppText',

  props: {
    /**
     * テキストの色。
     * normal(default) | error | primary
     */
    color: {
      type: String as PropType<TextColor>,
      required: false,
      default: TEXT_COLOR.DEFAULT,
    },

    /**
     * 行の高さ。
     * 原則テキストのサイズで決まるが、上書きする場合のみ指定。
     * 100 | 125 | 150
     */
    height: {
      type: String as PropType<LineHeight>,
      required: false,
      default: null,
    },

    /**
     * テキストのサイズ。
     * subtitle1 | body2(default) | caption | heading | heading6
     */
    size: {
      type: String as PropType<TextSize>,
      required: false,
      default: TEXT_SIZE.BODY2,
    },

    /**
     * 行の高さ。
     * 原則テキストのサイズで決まるが、上書きする場合のみ指定。
     * 1
     */
    spacing: {
      type: String as PropType<LetterSpacing>,
      required: false,
      default: null,
    },

    /**
     * テキストの下線。(使用中止)
     * defaultはfalseです。下線を入れる場合はtrueを入れてください。
     */
    // underline: {
    //   type: Boolean,
    //   required: false,
    //   default: false,
    // },

    /**
     * テキストの整列
     * 400(default) / 700
     */
    weight: {
      type: String as PropType<TextWeight>,
      required: false,
      default: TEXT_WEIGHT.WEIGHT400,
    },
  },

  setup(props) {
    const { themeParameter } = useContext(ThemeContext);
    const primaryColor = computed(() => themeParameter.value.primaryColor);
    const groupClasses = computed(() =>
      bemx('AppText', {
        color: TEXT_COLOR_MAP[props.color],
        height: LINE_HEIGHT_MAP[props.height] || SIZE_HEIGHT_MAP[props.size],
        size: TEXT_SIZE_MAP[props.size],
        spacing: LETTER_SPACING_MAP[props.spacing],
        weight: TEXT_WEIGHT_MAP[props.weight],
      }),
    );

    useCss(
      () => `
        .AppText.AppText--color-primary {
          color: ${primaryColor.value};
        }
     `,
    );

    return {
      groupClasses,
    };
  },
});
